import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.tsx'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7886c98d from 'nuxt_plugin_plugin_7886c98d' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_a913e632 from 'nuxt_plugin_sentryserver_a913e632' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_45bc9b5f from 'nuxt_plugin_sentryclient_45bc9b5f' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_pluginserver_3dd1e98a from 'nuxt_plugin_pluginserver_3dd1e98a' // Source: ./plugin.server.js (mode: 'server')
import nuxt_plugin_nuxtmq_f2b2b72a from 'nuxt_plugin_nuxtmq_f2b2b72a' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_index_2b5ae26a from 'nuxt_plugin_index_2b5ae26a' // Source: ./firebase/index.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_7687cc6a from 'nuxt_plugin_cookieuniversalnuxt_7687cc6a' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_826dbfba from 'nuxt_plugin_axios_826dbfba' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_recaptcha_6b1a35dc from 'nuxt_plugin_recaptcha_6b1a35dc' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_localstorage_63be1e63 from 'nuxt_plugin_localstorage_63be1e63' // Source: ../plugins/local-storage (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e' // Source: ../plugins/auth (mode: 'all')
import nuxt_plugin_reachGoal_2c294470 from 'nuxt_plugin_reachGoal_2c294470' // Source: ../plugins/reachGoal (mode: 'all')
import nuxt_plugin_vueClamp_983ecc68 from 'nuxt_plugin_vueClamp_983ecc68' // Source: ../plugins/vueClamp.js (mode: 'all')
import nuxt_plugin_vueAgile_2d9a75aa from 'nuxt_plugin_vueAgile_2d9a75aa' // Source: ../plugins/vueAgile.js (mode: 'all')
import nuxt_plugin_vueTooltip_91641cf8 from 'nuxt_plugin_vueTooltip_91641cf8' // Source: ../plugins/vueTooltip.js (mode: 'all')
import nuxt_plugin_vueClickOutside_eab7cd2c from 'nuxt_plugin_vueClickOutside_eab7cd2c' // Source: ../plugins/vueClickOutside.js (mode: 'all')
import nuxt_plugin_veeValidate_704b86be from 'nuxt_plugin_veeValidate_704b86be' // Source: ../plugins/veeValidate.js (mode: 'all')
import nuxt_plugin_vueTheMask_12e08c4a from 'nuxt_plugin_vueTheMask_12e08c4a' // Source: ../plugins/vueTheMask.js (mode: 'all')
import nuxt_plugin_construction_2918a972 from 'nuxt_plugin_construction_2918a972' // Source: ../plugins/construction (mode: 'all')
import nuxt_plugin_vueTruncateCollapsed_53606994 from 'nuxt_plugin_vueTruncateCollapsed_53606994' // Source: ../plugins/vueTruncateCollapsed.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_vueSlickCarousel_12582ab0 from 'nuxt_plugin_vueSlickCarousel_12582ab0' // Source: ../plugins/vueSlickCarousel (mode: 'all')
import nuxt_plugin_vueIntersectionObserver_37ba0c44 from 'nuxt_plugin_vueIntersectionObserver_37ba0c44' // Source: ../plugins/vueIntersectionObserver.ts (mode: 'all')
import nuxt_plugin_init_6a81d586 from 'nuxt_plugin_init_6a81d586' // Source: ../plugins/init (mode: 'server')
import nuxt_plugin_typeDevice_1b248626 from 'nuxt_plugin_typeDevice_1b248626' // Source: ../plugins/typeDevice (mode: 'all')
import nuxt_plugin_sessionTimer_38e45cc5 from 'nuxt_plugin_sessionTimer_38e45cc5' // Source: ../plugins/sessionTimer (mode: 'client')
import nuxt_plugin_firebase_5cf99106 from 'nuxt_plugin_firebase_5cf99106' // Source: ../plugins/firebase (mode: 'client')
import nuxt_plugin_vueScrollBar_725a16be from 'nuxt_plugin_vueScrollBar_725a16be' // Source: ../plugins/vueScrollBar.js (mode: 'client')
import nuxt_plugin_vueSlick_3f0afbcf from 'nuxt_plugin_vueSlick_3f0afbcf' // Source: ../plugins/vueSlick.js (mode: 'client')
import nuxt_plugin_vueYmap_06e8b464 from 'nuxt_plugin_vueYmap_06e8b464' // Source: ../plugins/vueYmap.js (mode: 'client')
import nuxt_plugin_yandex_4bd481b0 from 'nuxt_plugin_yandex_4bd481b0' // Source: ../plugins/yandex.js (mode: 'client')
import nuxt_plugin_vk_33245d28 from 'nuxt_plugin_vk_33245d28' // Source: ../plugins/vk.js (mode: 'client')
import nuxt_plugin_onlineChat_3168abd4 from 'nuxt_plugin_onlineChat_3168abd4' // Source: ../plugins/onlineChat.js (mode: 'client')
import nuxt_plugin_livetex_147c775c from 'nuxt_plugin_livetex_147c775c' // Source: ../plugins/livetex.js (mode: 'client')
import nuxt_plugin_showNotificationServer_632b38e1 from 'nuxt_plugin_showNotificationServer_632b38e1' // Source: ../plugins/showNotificationServer (mode: 'client')
import nuxt_plugin_showSmartBanner_e3d2e63c from 'nuxt_plugin_showSmartBanner_e3d2e63c' // Source: ../plugins/showSmartBanner (mode: 'client')
import nuxt_plugin_vueProgress_4f46489d from 'nuxt_plugin_vueProgress_4f46489d' // Source: ../plugins/vueProgress (mode: 'client')
import nuxt_plugin_webim_6e654e16 from 'nuxt_plugin_webim_6e654e16' // Source: ../plugins/webim.js (mode: 'client')
import nuxt_plugin_vueImageZoomPlugin_4b8a4031 from 'nuxt_plugin_vueImageZoomPlugin_4b8a4031' // Source: ../plugins/vueImageZoomPlugin (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Интернет аптека 24farmacia.ru","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"name":"smartbanner:button-url-apple","content":"https:\u002F\u002Fapps.apple.com\u002Fru\u002Fapp\u002F%D1%84%D0%B0%D1%80%D0%BC%D0%B0%D1%86%D0%B8%D1%8F\u002Fid1282232555"},{"name":"smartbanner:button-url-google","content":"https:\u002F\u002Fplay.google.com\u002Fstore\u002Fapps\u002Fdetails?id=com.ionicframework.myionic2project925427&hl=en_US&gl=US"},{"name":"smartbanner:enabled-platforms","content":"android,ios"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"src":"https:\u002F\u002Fyandex.ru\u002Fads\u002Fsystem\u002Fcontext.js","async":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7886c98d === 'function') {
    await nuxt_plugin_plugin_7886c98d(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_a913e632 === 'function') {
    await nuxt_plugin_sentryserver_a913e632(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_45bc9b5f === 'function') {
    await nuxt_plugin_sentryclient_45bc9b5f(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_3dd1e98a === 'function') {
    await nuxt_plugin_pluginserver_3dd1e98a(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_f2b2b72a === 'function') {
    await nuxt_plugin_nuxtmq_f2b2b72a(app.context, inject)
  }

  if (typeof nuxt_plugin_index_2b5ae26a === 'function') {
    await nuxt_plugin_index_2b5ae26a(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_7687cc6a === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_7687cc6a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_826dbfba === 'function') {
    await nuxt_plugin_axios_826dbfba(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_6b1a35dc === 'function') {
    await nuxt_plugin_recaptcha_6b1a35dc(app.context, inject)
  }

  if (typeof nuxt_plugin_localstorage_63be1e63 === 'function') {
    await nuxt_plugin_localstorage_63be1e63(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6a7e4e1e === 'function') {
    await nuxt_plugin_auth_6a7e4e1e(app.context, inject)
  }

  if (typeof nuxt_plugin_reachGoal_2c294470 === 'function') {
    await nuxt_plugin_reachGoal_2c294470(app.context, inject)
  }

  if (typeof nuxt_plugin_vueClamp_983ecc68 === 'function') {
    await nuxt_plugin_vueClamp_983ecc68(app.context, inject)
  }

  if (typeof nuxt_plugin_vueAgile_2d9a75aa === 'function') {
    await nuxt_plugin_vueAgile_2d9a75aa(app.context, inject)
  }

  if (typeof nuxt_plugin_vueTooltip_91641cf8 === 'function') {
    await nuxt_plugin_vueTooltip_91641cf8(app.context, inject)
  }

  if (typeof nuxt_plugin_vueClickOutside_eab7cd2c === 'function') {
    await nuxt_plugin_vueClickOutside_eab7cd2c(app.context, inject)
  }

  if (typeof nuxt_plugin_veeValidate_704b86be === 'function') {
    await nuxt_plugin_veeValidate_704b86be(app.context, inject)
  }

  if (typeof nuxt_plugin_vueTheMask_12e08c4a === 'function') {
    await nuxt_plugin_vueTheMask_12e08c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_construction_2918a972 === 'function') {
    await nuxt_plugin_construction_2918a972(app.context, inject)
  }

  if (typeof nuxt_plugin_vueTruncateCollapsed_53606994 === 'function') {
    await nuxt_plugin_vueTruncateCollapsed_53606994(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_vueSlickCarousel_12582ab0 === 'function') {
    await nuxt_plugin_vueSlickCarousel_12582ab0(app.context, inject)
  }

  if (typeof nuxt_plugin_vueIntersectionObserver_37ba0c44 === 'function') {
    await nuxt_plugin_vueIntersectionObserver_37ba0c44(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_init_6a81d586 === 'function') {
    await nuxt_plugin_init_6a81d586(app.context, inject)
  }

  if (typeof nuxt_plugin_typeDevice_1b248626 === 'function') {
    await nuxt_plugin_typeDevice_1b248626(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sessionTimer_38e45cc5 === 'function') {
    await nuxt_plugin_sessionTimer_38e45cc5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_firebase_5cf99106 === 'function') {
    await nuxt_plugin_firebase_5cf99106(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueScrollBar_725a16be === 'function') {
    await nuxt_plugin_vueScrollBar_725a16be(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueSlick_3f0afbcf === 'function') {
    await nuxt_plugin_vueSlick_3f0afbcf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueYmap_06e8b464 === 'function') {
    await nuxt_plugin_vueYmap_06e8b464(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yandex_4bd481b0 === 'function') {
    await nuxt_plugin_yandex_4bd481b0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vk_33245d28 === 'function') {
    await nuxt_plugin_vk_33245d28(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_onlineChat_3168abd4 === 'function') {
    await nuxt_plugin_onlineChat_3168abd4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_livetex_147c775c === 'function') {
    await nuxt_plugin_livetex_147c775c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_showNotificationServer_632b38e1 === 'function') {
    await nuxt_plugin_showNotificationServer_632b38e1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_showSmartBanner_e3d2e63c === 'function') {
    await nuxt_plugin_showSmartBanner_e3d2e63c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueProgress_4f46489d === 'function') {
    await nuxt_plugin_vueProgress_4f46489d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webim_6e654e16 === 'function') {
    await nuxt_plugin_webim_6e654e16(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueImageZoomPlugin_4b8a4031 === 'function') {
    await nuxt_plugin_vueImageZoomPlugin_4b8a4031(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
